document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('.site-header');
	const menuPanel = document.querySelector('.mobile-menu-template-holder');
	const burger = document.querySelector('.burger');

	if (!burger || !header || !menuPanel) return;

	const menuItems = menuPanel.querySelectorAll(
		'.mobile-menu-item, .wp-block-navigation, .wp-block-group, .wp-block-cs-premium-ui-kit-mobile-nav-search-wrapper'
	);

	let isOpen = false;

	const updatePanelPosition = () => {
		const headerHeight = header.offsetHeight;
		menuPanel.style.top = `${headerHeight}px`;
		menuPanel.style.height = `calc(100vh - ${headerHeight}px)`;
	};

	updatePanelPosition();
	window.addEventListener('resize', updatePanelPosition);
	window.addEventListener('load', updatePanelPosition);

	// Make sure menu panel and items are fully hidden on load
	gsap.set(menuPanel, { y: '-100%', opacity: 0, display: 'none' });
	gsap.set(menuItems, { opacity: 0, y: 20, display: 'none' });

	burger.addEventListener('click', (e) => {
		e.preventDefault();

		isOpen = !isOpen;
		burger.classList.toggle('open', isOpen);

		if (isOpen) {
			updatePanelPosition();
			gsap.set(menuPanel, { display: 'block' });
			gsap.set(menuItems, { display: 'block' });

			gsap.to(menuPanel, {
				duration: 0.3,
				y: '0%',
				opacity: 1,
				ease: 'power2.out',
				onComplete: () => {
					gsap.to(menuItems, {
						opacity: 1,
						y: 0,
						stagger: 0.1,
						duration: 0.4,
						ease: 'power2.out'
					});
				}
			});
		} else {
			gsap.to(menuItems, {
				opacity: 0,
				y: 20,
				duration: 0.1,
				ease: 'power2.in',
				onComplete: () => {
					gsap.set(menuItems, { display: 'none' });
				}
			});

			gsap.to(menuPanel, {
				duration: 0.3,
				y: '-100%',
				opacity: 0,
				ease: 'power2.in',
				onComplete: () => {
					gsap.set(menuPanel, { display: 'none' });
				}
			});
		}
	});
});